import React from "react";
import ApprovalScope from "./ApprovalScope";
import Footer from "../components/Footer";

// ICONS
import {
  FaMapMarkedAlt,
  FaDraftingCompass,
  FaBuilding,
  FaTree,
  FaTools,
  FaBolt,
  FaUserTie
} from "react-icons/fa";

import hero1 from "../image/bungalow-bg.png2.png";
import hero4 from "../image/bungalow-bg.png2.png";

const architectureData = [
  {
    id: "01",
    icon: <FaMapMarkedAlt />,
    title: "Site & Lifestyle Analysis",
    desc: "Study of client needs, climate response, plot conditions, orientation, and future expansion to establish the right planning direction.",
  },
  {
    id: "02",
    icon: <FaDraftingCompass />,
    title: "Concept Planning & Space Design",
    desc: "Layout options, zoning, circulation, and internal activity planning to create a home that feels natural, efficient, and comfortable.",
  },
  {
    id: "03",
    icon: <FaBuilding />,
    title: "Complete Architectural Drawings",
    desc: "Floor plans, elevations, sections, façade design, and 3D views to clearly visualize the bungalow before construction.",
  },
  {
    id: "04",
    icon: <FaTree />,
    title: "Site Planning & External Elements",
    desc: "Compound wall, entrance gate, drainage, paved areas, and utility positions coordinated within the site layout.",
  },
  {
    id: "05",
    icon: <FaTools />,
    title: "Construction-Ready Working Drawings",
    desc: "Centreline plans, setting-out plans, dimensional drawings, staircase & toilet details, and execution coordination.",
  },
  {
    id: "06",
    icon: <FaBolt />,
    title: "Service Integration Drawings",
    desc: "Electrical layouts, plumbing layouts, and service coordination drawings for smooth on site execution.",
  },
  {
    id: "07",
    icon: <FaUserTie />,
    title: "Site Visits & Consultant Coordination",
    desc: "Periodic site visits conducted on a need basis to review critical stages of construction and ensure alignment with the design intent. Coordination with structural and service consultants to address design-related queries, clarify drawings, and support smooth execution on site.",
  },
];

export default function Architecture({ openContactModal, showCTA }) {
  return (
    <div>
      <ApprovalScope
        heroTitle={`Custom Bungalow Architecture`}
        heroSubtitle="Designed for lifestyle, climate, and lasting functionality."
        heroImg={hero1}
        heroBg={hero4}

        sectionTitle="Architectural Design for Bungalows"

        topText="We specialize in designing bungalows tailored to the specific desires of your family, with an emphasis on site conditions, local climate, lifestyle needs, and future living requirements. Our commitment is crafting a bespoke, elegant home that stands the test of time through meticulous planning and sophisticated design"

        heading="Detailed Architectural Scope"
        data={architectureData}

        ctaTitle="The Dwellora Approach"

        ctaDesc="Because we design and build, there is no gap between drawings and execution. This ensures accuracy, accountability, and consistent quality throughout construction."

        ctaBtn="Let’s Consult"
        openContactModal={openContactModal}
      />

 <Footer 
  openContactModal={openContactModal}
  showCTA={showCTA} 
/>

    </div>
  );
}